<template>
    <div class="listing-detail-banner fashion" ref="banner">
        <!-- mobile top banner start -->
        <template v-if="isMobileSize">
            <div class="save-share-container" v-sticky="{ class: 'fixed' }">
                <div class="left-btn" @click="putAway">
                    <span class="btn-putAway iconfont icon-boldarrow"></span>
                    <span class="btn-text">{{
                        $t('md-detail-info.search')
                    }}</span>
                </div>
                <div class="right-btn">
                    <shake-animate>
                        <template #default="shakeStyle">
                            <div
                                class="item save"
                                :class="[!hasFavor && shakeStyle.animate]"
                                @click="onFavClick"
                                v-if="!isSoldHouse"
                            >
                                <span
                                    class="iconfont"
                                    :class="[
                                        hasFavor && !!user
                                            ? 'icon-heart-fill'
                                            : 'icon-heart'
                                    ]"
                                ></span>
                            </div>
                        </template>
                    </shake-animate>
                    <div class="item share" @click="sharePop">
                        <span class="iconfont icon-share-arrow"></span>
                    </div>
                </div>
            </div>
        </template>
        <!-- mobile top banner start -->
        <!-- pc top banner start -->
        <template v-else>
            <div
                class="fixed-banner"
                :class="{ fixed: showFixedBanner }"
                :style="fixedBannerStyle"
            >
                <div class="banner-box mg-container">
                    <div class="banner-left" v-if="prevAndNext.show">
                        <template v-if="prevAndNext.canPrev">
                            <a
                                class="btn"
                                :href="prevAndNext.prevHref || null"
                                self="true"
                                rel="noopener noreferrer"
                            >
                                <span
                                    class="iconfont icon-next-big prev"
                                ></span>
                                <span class="text">{{
                                    $t('md-detail-info.prev')
                                }}</span>
                            </a>
                            <div class="bg-img-box">
                                <site-img
                                    :src="prevAndNext.prevImg"
                                    class="bg-img"
                                />
                            </div>
                        </template>
                    </div>
                    <div class="center mg-container">
                        <div class="price-address">
                            <price class="price" />
                            <Addr theme="dark" class="address" />
                        </div>
                        <div class="save-share-tour">
                            <shake-animate>
                                <template #default="shakeStyle">
                                    <span
                                        class="item save"
                                        @click="onFavoriteClick"
                                        v-if="!isSoldHouse"
                                        :class="[
                                            hasFavor ? 'active' : '',
                                            !hasFavor && shakeStyle.animate
                                        ]"
                                    >
                                        <i class="iconfont icon-heart-fill"></i>
                                        <span class="btn-text">{{
                                            $t('md-detail-info.save')
                                        }}</span>
                                    </span>
                                </template>
                            </shake-animate>
                            <span class="item share">
                                <i class="iconfont icon-share-arrow"></i>
                                <span class="btn-text">{{
                                    $t('md-detail-info.share')
                                }}</span>
                                <share-popper
                                    class="popper"
                                    :shares="shares"
                                    :theme="theme"
                                    :listingId="info.id"
                                />
                            </span>
                            <span
                                @click="schedulePop"
                                class="item tour"
                                v-if="!isSoldHouse"
                            >
                                <span class="text">{{
                                    $t('md-detail-info.scheduleATour')
                                }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="banner-right" v-if="prevAndNext.show">
                        <template v-if="prevAndNext.canNext">
                            <a
                                class="btn"
                                :href="prevAndNext.nextHref || null"
                                self="true"
                                rel="noopener noreferrer"
                            >
                                <span class="text">{{
                                    $t('md-detail-info.next')
                                }}</span>
                                <span
                                    class="iconfont icon-next-big next"
                                ></span>
                            </a>
                            <div class="bg-img-box">
                                <site-img
                                    :src="prevAndNext.nextImg"
                                    class="bg-img"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <!-- pc top banner end -->
        <bread-crumb
            v-if="!isMobileSize && !wordPressSSR"
            theme="fashion"
            :detailInfo="info"
        />
        <Swiper
            class="detail-info-imgs"
            :class="{ 'align-center': allImages.length < slidesPerView }"
            trackSource="detail-info-img"
            v-bind="options"
            ref="swiper"
            @init="onSwiperReady"
            @slideChange="handleSlideChange"
        >
            <Slide
                v-for="(item, index) in allImages"
                :key="index"
                :class="`slide-${item.length}`"
            >
                <div class="swiper-box" @click="touched(index, $event, item)">
                    <div class="swiper-video" v-if="item.type == '3d'">
                        <img-box :src="item.preview" :alt="videoImgAlt">
                            <house-tag
                                v-bind="infoFlag.exclusiveTag"
                                v-if="infoFlag.exclusiveTag && isMobileSize"
                                theme="v4"
                            />
                        </img-box>
                    </div>
                    <img-box
                        v-else
                        @load="onImgLoad(index, $event)"
                        :lazy="lazyload"
                        :src="item"
                        :alt="imgAlt"
                        class="swiper-img"
                    >
                        <house-tag
                            v-bind="infoFlag.exclusiveTag"
                            v-if="infoFlag.exclusiveTag && isMobileSize"
                            theme="v4"
                        />
                    </img-box>
                </div>
            </Slide>
            <div class="swiper-button-prev iconfont icon-prev disabled"></div>
            <div class="swiper-button-next iconfont icon-prev"></div>
            <div
                class="image-count"
                v-if="allImages.length > 1"
                @click="touched(0)"
            >
                <span class="iconfont icon-pic"></span>
                {{ allImages.length }}
            </div>
        </Swiper>

        <PSwp
            :options="photoswipeOption"
            ref="pswp"
            defaultSize="1200x750"
            trackSource="detail-info-img"
        />
        <!--<VideoPlayer
            v-if="video && video.videoLink"
            theme="fashion"
            ref="videoPlayer"
            :url="video && video.videoLink"
        ></VideoPlayer>-->
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import common from '../banner.js';
import price from './detail-info-header/price.vue';
import Addr from '../_components/address.vue';
import shakeAnimate from '../shake-animate.vue';
import houseTag from '@/modules/md-house/_component/house-tag';
export default {
    emits: ['showFixedBannerChange'],
    mixins: [common],
    components: {
        price,
        Addr,
        shakeAnimate,
        houseTag
    },
    computed: {
        ...mapState({
            prevAndNext: 'prevAndNext',
            infoFlag: 'infoFlag'
        }),
        slidesPerView() {
            return this.isMobileSize ? 1 : 3;
        }
    },
    data: function() {
        return {
            speed: 1000,
            canPre: false,
            canNext: false,
            space: 2,
            theme: 'fashion',
            showFixedBanner: false
        };
    },
    methods: {
        onScroll() {
            let swiper = this.$refs.swiper;
            if (!swiper) {
                return; 
            }
            let rect = swiper.$el.getBoundingClientRect();
            if (rect.top < 0) {
                this.showFixedBanner = true;
                this.$emit('showFixedBannerChange', true);
            } else {
                this.showFixedBanner = false;
                this.$emit('showFixedBannerChange', false);
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';

.listing-detail-banner.fashion {
    // overflow: hidden;
    position: relative;
    // fix AM-298689
    @include media-min-600 {
        min-height: 400px;
    }
    .mls-provided.mg-container {
        line-height: 20px;
        font-size: 14px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 18px;
        color: #fff;
        z-index: 10;
        margin-left: 66px;
        &.margin {
            right: 40px;
        }
        @include media-600 {
            width: calc(100% - 120px);
            left: 0;
            transform: translateX(0);
            margin-left: 15px;
            bottom: 10px;
        }
    }
    .banner-schedule {
        cursor: initial;
        padding-top: 9px;
        visibility: hidden;
        width: 320px;
        position: absolute;
        right: 0;
        top: 100%;
        z-index: 3;
        font-family: var(--font-normal);
        text-align: left;
        // &>.table-schedule, &>tab-success{
        //     box-shadow: 0 5px 20px 0 rgba(170, 186, 218, 0.25);
        // }
    }
    .detail-info-imgs {
        height: 400px;
        overflow: hidden;
        &.align-center .swiper-wrapper {
            justify-content: center;
        }
        .swiper-button-prev,
        .swiper-button-next {
            position: absolute;
            bottom: 0;
            transform: translateY(-50%);
            z-index: 1;
            font-size: 35px;
            height: 100%;
            width: 100px;
            color: rgba(255, 255, 255, 0.6);
            opacity: 0.6;
            cursor: pointer;
            background-image: none;
            background-size: 100%;
            &:hover {
                background-image: linear-gradient(
                    90deg,
                    rgba(0, 0, 0, 0.6),
                    transparent
                );
                color: white;
            }
            &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            &:after {
                display: none;
            }
            &.swiper-button-disabled {
                opacity: 0.35;
            }
        }
        .swiper-button-prev {
            left: 0;
        }
        .swiper-button-next {
            right: 0;
            &:hover {
                background-image: linear-gradient(
                    270deg,
                    rgba(0, 0, 0, 0.6),
                    transparent
                );
            }
            &::before {
                transform: translate(-50%, -50%) rotate(180deg);
            }
        }
        .m-virtual-tour {
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 15px;
            width: 48px;
            height: 48px;
            color: rgba(255, 255, 255, 0.8);
            font-size: 16px;
            z-index: 2;
            text-align: center;
            line-height: 20px;
        }
        .swiper-slide {
            height: 100%;
            display: flex;
        }
        .swiper-box {
            height: 100%;
            width: 100%;
            cursor: pointer;
            .swiper-img {
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                }
                .house-status {
                    position: absolute;
                    left: 15px;
                    top: 15px;
                }
            }
            .swiper-video {
                height: 100%;
                position: relative;
                background: black;
                .play {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: url('//static.chimeroi.com/site3/images/play.png');
                    background-size: cover;
                    height: 60px;
                    width: 60px;
                }
                .img-box {
                    height: 100%;
                }
            }
        }

        .image-count {
            display: none;
            position: absolute;
            bottom: 10px;
            right: 15px;
            padding: 7px 8px;
            background-color: rgba(74, 74, 96, 0.8);
            font-size: 14px;
            color: white;
            z-index: var(--level-low);
        }
    }
    .fixed-banner .banner-box .center {
        .price-address {
            .price {
                .price-container {
                    .price-value,
                    .sold-price {
                        font-size: 24px;
                    }
                }
            }
            .address-container {
                margin-top: 10px;
            }
        }
    }
    .save-share-container {
        padding: 0 15px;
        height: 45px;
        background-color: #242a3d;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        &.fixed {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 100;
        }
        .left-btn {
            color: #ffffff;
            .btn-putAway {
                transform: rotate(180deg);
                display: inline-block;
            }
            .iconfont {
                font-size: 18px;
            }
            .btn-text {
                margin-left: 3px;
                font-size: 18px;
            }
        }
        .right-btn {
            .item {
                margin-right: 20px;
                display: inline-block;
                &:last-of-type {
                    margin-right: 0;
                }
                &.save {
                    color: #f0454c;
                }
                &.share {
                    color: #adb9d1;
                }
                .iconfont {
                    font-size: 20px;
                }
            }
        }
    }
    // pc top banner
    .fixed-banner {
        width: 100%;
        min-height: 80px;
        padding: 10px 0;
        background-color: #242a3d;
        position: fixed;
        top: 0;
        left: 0;
        z-index: var(--level-medium);
        opacity: 0;
        visibility: hidden;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        transition: all 0.3s ease;
        &.fixed {
            visibility: visible;
            opacity: 1;
        }
        .banner-box {
            margin: 0 auto;
            display: flex;
            justify-content: center;
            @media (min-width: 1210px) {
                .center {
                    margin: 0;
                }
            }
            .banner-left,
            .banner-right {
                width: 80px;
                position: relative;
                .bg-img-box {
                    opacity: 0;
                    &:after {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 60px;
                        top: 0;
                        left: 0;
                        background-color: rgba(0, 0, 0, 0.1);
                    }
                    .bg-img {
                        width: 80px;
                        height: 60px;
                        display: inline-block;
                    }
                }
                .btn {
                    color: #adb9d1;
                    position: absolute;
                    height: 25px;
                    width: 100%;
                    border-radius: 2px;
                    border: solid 1px #adb9d1;
                    text-align: center;
                    font-size: 14px;
                    font-family: var(--font-bold);
                    line-height: 23px;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    display: block;
                    &:hover {
                        cursor: pointer;
                        border: none;
                        color: #ffffff;
                        line-height: 25px;
                        + .bg-img-box {
                            opacity: 1;
                        }
                    }
                    .iconfont {
                        font-size: 12px;
                        &.prev {
                            transform: rotate(180deg);
                            display: inline-block;
                        }
                    }
                }
            }
            .center {
                display: flex;
                justify-content: space-between;
                align-items: center;
                &.mg-container {
                    &:after {
                        content: none;
                    }
                    @media (max-width: 1209px) {
                        width: auto;
                        flex: 1;
                        margin: 0;
                    }
                }
                .address {
                    max-width: 600px;
                    @media (max-width: 1209px) {
                        max-width: 400px;
                    }
                }
                .save-share-tour {
                    .item {
                        cursor: pointer;
                        text-align: center;
                        color: #adb9d1;
                        display: inline-block;
                        height: 40px;
                        margin-right: 30px;
                        &:last-child {
                            margin-right: 0;
                        }
                        .btn-text {
                            font-size: 12px;
                            line-height: 2;
                        }
                        > .iconfont {
                            font-size: 18px;
                            display: block;
                        }
                        &.save {
                            &.active,
                            &:hover {
                                color: #f0454c;
                            }
                        }
                        &.share {
                            position: relative;
                            &:hover {
                                color: #4476e5;
                                .popper {
                                    visibility: visible;
                                }
                            }
                            .popper {
                                position: absolute;
                                top: 100%;
                                left: 50%;
                                padding-top: 15px;
                                z-index: var(--level-medium);
                                transform: translateX(-50%);
                                visibility: hidden;
                            }
                        }
                        &.tour {
                            position: relative;
                            vertical-align: top;
                            padding: 10px 18px;
                            border-radius: 2px;
                            font-size: 16px;
                            font-family: var(--font-bold);
                            @include color-button();
                            &:hover {
                                @include color-button-hover();
                                .banner-schedule {
                                    visibility: visible;
                                }
                            }
                            .text {
                                display: inline-block;
                                max-width: 250px;
                                @include ellipsis();
                            }
                        }
                    }
                }
            }
            .banner-left {
                margin-right: 20px;
            }
            .banner-right {
                margin-left: 20px;
            }
        }
    }
}

@include media-600 {
    .listing-detail-banner.fashion {
        margin-top: 0;
        .swiper.detail-info-imgs {
            height: 250px;
            .swiper-wrapper {
                .swiper-slide {
                    width: 100%;
                }
            }
            .image-count {
                display: block;
            }
        }
    }
}

@mixin slideLeft() {
    width: 50%;
    flex: 1;
    height: 100%;
    margin-right: 2px;
}
</style>
